<app-breadcrumb [title]="'Nuevo'" [items]="['Personas']" [active_item]="'Nuevo'"></app-breadcrumb>
<div class="container-fluid">
<div class="col-sm-12 col-xl-12">
  <ngb-accordion [closeOthers]="true" [activeIds]="activePanel" [destroyOnHide]="false" #accordion="ngbAccordion">
    <ngb-panel id="static-1">
      <ng-template ngbPanelTitle>
        <i class="fa fa-info-circle"></i>
        <span (click)="togglePanel('static-1')" class="ms-2"><strong>Datos Básicos</strong></span>
      </ng-template>
      <ng-template ngbPanelContent>
        <div class="card">
          <div class="card-body">
            <form [ngClass]="{ 'was-validated': validate }" class="needs-validation" novalidate (ngSubmit)="saveData()">
              <div class="row g-3 mb-3">
                <div class="col-md-3">
                  <label class="form-label" for="tipo"> <strong>Tipo de Documento:</strong><a class="text-danger">*</a></label>
                  <select id="tipo" #inputTipo class="form-select" [(ngModel)]="formData.tipo" name="tipo" required
                    #tipoSelect="ngModel" placeholder="Selecciona una opción"
                    [ngClass]="{ 'is-invalid': errores.tipo }">
                    <option *ngFor="let opcion of TipoDeDocumento" [value]="opcion.value">
                      {{ opcion.label }}
                    </option>
                  </select>

                  <div class="invalid-feedback" *ngIf="errores.tipo">
                    {{ errores.tipo }}
                  </div>
                </div>

                <div class="col-md-3">
                  <label class="form-label" for="cedula"><strong>Número de Documento:</strong><a class="text-danger">*</a></label>
                  <input #inputCedula class="form-control" id="cedula" type="number" placeholder="Número de documento"
                    [(ngModel)]="formData.cedula" name="cedula" required (blur)="verificarCedula()"
                    [ngClass]="{ 'is-invalid': errores.cedula }" />
                  <div class="invalid-feedback" *ngIf="errores.cedula">
                    {{ errores.cedula }}
                  </div>
                </div>

                <div class="col-md-3">
                  <label class="form-label"><strong>Lugar de Expedición:</strong></label>
                  <ng-select id="lugarex" [items]="municipios" bindLabel="MUNICIPIO" bindValue="IDMUN"
                    placeholder="Selecciona una opción" class="js-example-placeholder-multiple" name="lugarex"
                    [(ngModel)]="formData.lugarex">
                    <ng-template ng-label-tmp let-item="item">
                      <span class="text-uppercase">
                        {{ item.MUNICIPIO }} ({{ item.departamento?.nombre }})
                      </span>
                    </ng-template>

                    <ng-template ng-option-tmp let-item="item">
                      <span class="text-uppercase">
                        {{ item.MUNICIPIO }} ({{ item.departamento?.nombre }})
                      </span>
                    </ng-template>


                  </ng-select>
                </div>


                <div class="col-md-3">
                  <label class="form-label" for="primernombre"><strong>Primer Nombre:</strong><a class="text-danger">*</a></label>
                  <input #inputPrimernombre class="form-control text-uppercase" id="primernombre" type="text"
                    placeholder="Ingrese primer nombre" [(ngModel)]="formData.primernombre" name="primernombre" required
                    [ngClass]="{ 'is-invalid': errores.primernombre }" (keypress)="soloLetras($event)" />
                  <div class="invalid-feedback" *ngIf="errores.primernombre">
                    {{ errores.primernombre }}
                  </div>
                </div>

                <div class="col-md-3">
                  <label class="form-label" for="validationCustom01"><strong>Segundo Nombre:</strong></label>
                  <input class="form-control text-uppercase" id="segundonombre" type="text"
                    placeholder="Ingrese segundo nombre" [(ngModel)]="formData.segundonombre" name="segundonombre"
                    (keypress)="soloLetras($event)" />
                </div>
                <div class="col-md-3">
                  <label class="form-label" for=""><strong>Primer Apellido:</strong><a class="text-danger">*</a></label>
                  <input #inputPapellidos class="form-control text-uppercase" id="papellidos" type="text"
                    placeholder="Ingrese primer apellido" [(ngModel)]="formData.papellidos" name="papellidos" required
                    [ngClass]="{ 'is-invalid': errores.papellidos }" (keypress)="soloLetras($event)" />
                  <div class="invalid-feedback" *ngIf="errores.papellidos">
                    {{ errores.papellidos }}
                  </div>
                </div>
                <div class="col-md-3">
                  <label class="form-label" for="Ingrese segundo apellido"><strong>Segundo Apellido:</strong></label>
                  <input class="form-control text-uppercase" id="seapellidos" type="text"
                    placeholder="ingrese segundo apellido" [(ngModel)]="formData.seapellidos" name="seapellidos"
                    (keypress)="soloLetras($event)" />
                </div>
                <div class="col-md-3">
                  <label class="form-label" for="fechanace">
                    <strong>Fecha de Nacimiento:</strong><a class="text-danger">*</a>
                  </label>
                  <div class="input-group input-group-sm">
                    <input #inputFechanacimiento type="date" id="fechanace" class="form-control form-control-lg fs-14"
                      [(ngModel)]="formData.fechanacimiento" (change)="onDateChange($event.target.value, 'fechanace')"
                      name="fechanace" required [ngClass]="{ 'is-invalid': errores.fechanace }"
                      [max]="fechaMaximaPermitida" />
                    <div class="invalid-feedback" *ngIf="errores.fechanace">
                      {{ errores.fechanace }}
                    </div>
                  </div>
                </div>

                <div class="col-md-3">
                  <label class="form-label" for="edad"><strong>Edad:</strong></label>
                  <div class="input-group bootstrap-touchspin">
                    <input type="number" id="edad" class="form-control" [(ngModel)]="formData.edad" name="edad" readonly
                      disabled />
                  </div>
                </div>

                <div class="col-md-3">
                  <label class="form-label" for="lugarnace"><strong>Lugar de Nacimiento:</strong></label>
                  <ng-select id="lugarnace" [items]="municipios" bindLabel="MUNICIPIO" bindValue="IDMUN"
                    placeholder="Seleciona una opción" class="js-example-placeholder-multiple"
                    [(ngModel)]="formData.lugarnace" name="lugarnace">
                    <ng-template ng-label-tmp let-item="item">
                      <span class="text-uppercase">
                        {{ item.MUNICIPIO }} ({{ item.departamento?.nombre }})
                      </span>
                    </ng-template>

                    <ng-template ng-option-tmp let-item="item">
                      <span class="text-uppercase">
                        {{ item.MUNICIPIO }} ({{ item.departamento?.nombre }})
                      </span>
                    </ng-template>
                  </ng-select>
                </div>
                <div class="col-md-3">
                  <label class="form-label" for="genero"><strong>Género:</strong></label>
                  <select id="genero" #inputGenero class="form-select" [(ngModel)]="formData.genero" name="genero"
                     #tipoSelect="ngModel" placeholder="Selecciona una opción">
                    <option *ngFor="let opcion of Genero" [value]="opcion.label">
                      {{ opcion.label }}
                    </option>
                  </select>

                  <!-- <div class="invalid-feedback" *ngIf="errores.genero">
                    {{ errores.genero }}
                  </div> -->
                </div>
                <div class="col-md-3">
                  <label class="form-label" for="civil"><strong>Estado Civil:</strong></label>
                  <select id="civil" #inputEstadocivil class="form-select" [(ngModel)]="formData.civil" name="civil"
                     #tipoSelect="ngModel" placeholder="Selecciona una opción"
                    [ngClass]="{ 'is-invalid': errores.civil }">
                    <option *ngFor="let opcion of dataCiviles" [value]="opcion.id">
                      {{ opcion.descripcion }}
                    </option>
                  </select>

                  <div class="invalid-feedback" *ngIf="errores.civil">
                    {{ errores.civil }}
                  </div>
                </div>


                <div class="col-md-3">
                  <label class="form-label" for="validationCustom01">
                    <strong>Tipo de sangre:</strong></label>
                  <ng-select id="sangre" [items]="TipoDeSangre" bindLabel="label" bindValue="label"
                    placeholder="Seleciona una opción" class="js-example-placeholder-multiple"
                    [(ngModel)]="formData.sangre" name="sangre">
                  </ng-select>
                </div>
                <div class="col-md-3">
                  <label class="form-label" for=""><strong>Dirección:</strong></label>
                  <input id="direccion" class="form-control" type="text" placeholder="Ingrese dirección"
                    [(ngModel)]="formData.direccion" name="direccion" />
                </div>
                <div class="col-md-3">
                  <label class="form-label" for=""><strong>Ciudad:</strong></label>
                  <ng-select id="ciudad" [items]="municipios" bindLabel="MUNICIPIO" bindValue="IDMUN"
                    placeholder="Seleciona una opción" class="js-example-placeholder-multiple"
                    [(ngModel)]="formData.ciudad" name="ciudad">
                    <ng-template ng-label-tmp let-item="item">
                      <span class="text-uppercase">
                        {{ item.MUNICIPIO }} ({{ item.departamento?.nombre }})
                      </span>
                    </ng-template>

                    <ng-template ng-option-tmp let-item="item">
                      <span class="text-uppercase">
                        {{ item.MUNICIPIO }} ({{ item.departamento?.nombre }})
                      </span>
                    </ng-template>
                  </ng-select>
                </div>
                <div class="col-md-3">
                  <label class="form-label" for=""><strong>Barrio:</strong></label>
                  <input class="form-control" id="barrio" type="text" placeholder="Ingrese barrio"
                    [(ngModel)]="formData.barrio" name="barrio" />
                </div>

                <div class="col-md-3">
                  <label class="form-label" for="civil"><strong>Estrato:</strong></label>
                  <select id="estrato" #inputEstratos class="form-select" [(ngModel)]="formData.estrato" name="estrato"
                     #tipoSelect="ngModel" placeholder="Selecciona una opción"
                    [ngClass]="{ 'is-invalid': errores.estrato }">
                    <option *ngFor="let opcion of Estrato" [value]="opcion.value">
                      {{ opcion.label }}
                    </option>
                  </select>

                  <div class="invalid-feedback" *ngIf="errores.estrato">
                    {{ errores.estrato }}
                  </div>
                </div>
                <div class="col-md-3">
                  <label class="form-label" for=" "><strong>Teléfono Fijo:</strong></label>
                  <input class="form-control" id="telfijo" type="text" placeholder="Ingrese teléfono fijo"
                    [(ngModel)]="formData.telfijo" name="telfijo" maxlength="10" (input)="validarTelefono($event)" />

                </div>
                <div class="col-md-3">
                  <label class="form-label" for=""><strong>Teléfono Celular:</strong></label>
                  <input class="form-control" id="telcel" type="text" placeholder="Ingrese teléfono celular"
                    [(ngModel)]="formData.telcel" name="telcel" maxlength="10"
                    (input)="validarTelefonoCelular($event)" />

                </div>
                <div class="col-md-3">
                  <label class="form-label" for=""><strong>Celular Empresarial:</strong></label>
                  <input class="form-control" id="telempresa" type="text" placeholder="Ingrese celular empresarial"
                    [(ngModel)]="formData.telempresa" name="teleempresa" maxlength="10"
                    (input)="validarteleempresa($event)" />
                </div>

                <div class="col-md-3">
                  <label class="form-label" for="mail"><strong>Correo Electrónico:</strong></label>
                  <input #inputGmail class="form-control" id="mail" type="email"
                    placeholder="Ingrese correo electrónico" [(ngModel)]="formData.mail" name="mail"
                    (input)="validarCorreo()" />
                  <div class="text-danger" *ngIf="errores.mail">
                    {{ errores.mail }}
                  </div>
                </div>

                <div class="col-md-3">
                  <label class="form-label" for=""><strong>Entidad Bancaria:</strong></label>
                  <ng-select id="banco" [items]="bancos" bindLabel="bancos" bindValue="nit"
                    placeholder="Seleciona una opción" class="js-example-placeholder-multiple"
                    [(ngModel)]="formData.banco" name="banco">
                  </ng-select>
                </div>
                <div class="col-md-3">
                  <label class="form-label" for=""> <strong>Tipo de Cuenta:</strong></label>
                  <ng-select id="tipocuenta" [items]="TipoDeCuenta" bindLabel="label" bindValue="label"
                    placeholder="Seleciona una opción" class="js-example-placeholder-multiple"
                    [(ngModel)]="formData.tipocuenta" name="tipocuenta">
                  </ng-select>
                </div>
                <div class="col-md-3">
                  <label class="form-label" for=""> <strong>Número de Cuenta:</strong></label>
                  <input class="form-control" id="cuenta" type="number" placeholder="Ingrese numero de cuenta"
                    [(ngModel)]="formData.cuenta" name="cuenta" />
                </div>

                <div class="col-md-3">
                  <label class="form-label" for="raza"><strong>Raza o grupo étnico:</strong></label>
                  <select id="raza" #inputRaza class="form-select" [(ngModel)]="formData.raza" name="raza" 
                    #tipoSelect="ngModel" placeholder="Selecciona una opción"
                    [ngClass]="{ 'is-invalid': errores.raza }">
                    <option *ngFor="let opcion of dataRaza" [value]="opcion.id">
                      {{ opcion.descripcion }}
                    </option>
                  </select>

                  <div class="invalid-feedback" *ngIf="errores.raza">
                    {{ errores.raza }}
                  </div>
                </div>

                <div class="col-md-3">
                  <label class="form-label" for="vivienda"><strong>Tipo de Vivienda:</strong></label>
                  <select id="vivienda" #inputTipodevivienda class="form-select" [(ngModel)]="formData.vivienda"
                    name="vivienda"  #tipoSelect="ngModel" placeholder="Selecciona una opción"
                    [ngClass]="{ 'is-invalid': errores.vivienda }">
                    <option *ngFor="let opcion of TipoDeVivienda" [value]="opcion.id">
                      {{ opcion.nombre }}
                    </option>
                  </select>

                  <div class="invalid-feedback" *ngIf="errores.vivienda">
                    {{ errores.vivienda }}
                  </div>
                </div>
                <div class="col-md-3">
                  <label class="form-label" for="nucleo"><strong>Núcleo Familiar:</strong></label>
                  <ng-select id="nucleo" [items]="NucleoFamiliar" bindLabel="descripcion" bindValue="id"
                    placeholder="Selecciona una opción" class="js-example-placeholder-multiple"
                    [(ngModel)]="formData.nucleo" name="nucleo">
                  </ng-select>
                </div>

                <div class="col-md-3">
                  <label class="form-label" for=""><strong>Padre de Familia:</strong></label>
                  <ng-select id="padre" [items]="PadreFamiliar" bindLabel="label" bindValue="label"
                    placeholder="Selecciona una opción" class="js-example-placeholder-multiple"
                    [(ngModel)]="formData.padre" name="padre" (change)="onPadreChange()">
                  </ng-select>
                </div>

                <div *ngIf="formData.padre === 'SI'" class="col-md-3">
                  <label class="form-label" for="nhijos"><strong>Número de Hijos:</strong></label>
                  <input type="number" id="nhijos" class="form-control" [(ngModel)]="formData.nhijos" name="nhijos"
                    placeholder="Ingresa el número de hijos" />
                </div>
                <div class="col-md-3">
                  <label class="form-label" for="validationCustom01">
                   <strong> Area:</strong></label>
                  <ng-select id="area" [items]="areaData" bindLabel="descripcion" bindValue="id"
                    placeholder="Seleciona una opción" class="js-example-placeholder-multiple"
                    [(ngModel)]="formData.area" name="area">
                  </ng-select>
                </div>
                <!--  <div class="col-md-3">
                  <label class="form-label"  for="">
                    Perfil</label
                  >
                  <ng-select
                    [items]="area"
                    bindLabel="label"
                    bindValue="value"
                    placeholder="Seleciona una opción"
                    class="js-example-placeholder-multiple"
                    [(ngModel)]="perfil"
                  >
                  </ng-select>
                </div>
                -->
                <div class="col-md-3">
                  <label class="form-label" for=""><strong>Contraseña:</strong></label>
                  <input class="form-control" id="password" type="text" placeholder=" " disabled
                    [(ngModel)]="formData.password" name="password" />
                </div>
                <div class="col-md-3">
                  <label class="form-label" for="">
                    Confirme su Contraseña:</label>
                  <input class="form-control" id="" type="text" placeholder=" " disabled />
                </div>
              </div>

              <div class="row g-3 mb-3">
                <div class="mb-3">
                  <label class="form-label" for="observaciones"><strong>Observaciones:</strong></label>
                  <textarea class="form-control" id="observaciones" [(ngModel)]="formData.observaciones"
                    name="observaciones" rows="3"></textarea>
                </div>
              </div>

              <!-- Componente de Firma -->
              <div class="row g-3 mb-3">
                <div class="mb-3">
                  <app-firmas [cedula]="formData.cedula" (firmaCargada)="onFirmaCargada($event)"></app-firmas>
                </div>
              </div>

              <br />
            </form>
          </div>
        </div>
      </ng-template>
    </ngb-panel>

    <ngb-panel id="static-2">
      <ng-template ngbPanelTitle>
        <i class="fa fa-suitcase"></i><!-- Ícono (puedes cambiar la clase) -->
        <span class="ms-2"><strong>Contrato Laboral</strong></span>
      </ng-template>
      <ng-template ngbPanelContent>
        <div class="card">
          <div class="card-header">
            <form [ngClass]="{ 'was-validated': validate }" class="needs-validation" novalidate>
              <div class="row g-3 mb-3">

                <div class="col-md-3">
                  <label class="form-label" for="condicion">
                    <strong>Condición Laboral:</strong><a class="text-danger">*</a>
                  </label>
                  <select #inputCondicion id="condicion" class="form-select" [(ngModel)]="formData.condicion"
                    name="condicion" required [ngClass]="{ 'is-invalid': errores.condicion }">
                    <option value="" disabled selected>
                      Selecciona una opción
                    </option>
                    <option *ngFor="let opcion of datacondicion" [value]="opcion.value">
                      {{ opcion.label }}
                    </option>
                  </select>
                  <div class="invalid-feedback" *ngIf="errores.condicion">
                    {{ errores.condicion }}
                  </div>
                </div>
                <div class="col-md-3">
                  <label class="form-label" for="cargo">
                    <strong>Cargo del Empleado:</strong><a class="text-danger">*</a>
                  </label>
                  <select #inputCargos id="cargo" class="form-select" [(ngModel)]="formData.cargo" name="cargo" required
                    (change)="validarCargo()" [ngClass]="{ 'is-invalid': errores.cargo }">
                    <option value="" disabled selected>
                      Selecciona una opción
                    </option>
                    <option *ngFor="let opcion of datacargos" [value]="opcion.id">
                      {{ opcion.cargos }}
                    </option>
                  </select>
                  <div class="invalid-feedback" *ngIf="errores.cargo">
                    {{ errores.cargo }}
                  </div>
                </div>

                <div class="col-md-3" *ngIf="formData.cargo === '2'">
                  <label class="form-label" for="categoria"><strong>Categoría:</strong><a class="text-danger">*</a></label>
                  <select #inputCategoria id="categoria" class="form-select" [(ngModel)]="formData.categoria"
                    name="categoria" required [disabled]="formData.cargo !== '2'" (change)="validarCargo()" [ngClass]="{
                      'is-invalid': errores.categoria && validarEnvio
                    }">
                    <option value="" disabled selected>
                      Seleccione una categoría
                    </option>
                    <option *ngFor="let opcion of Categoria" [value]="opcion.label" [disabled]="opcion.disabled">
                      {{ opcion.label }}
                    </option>
                  </select>
                  <div *ngIf="errores.categoria && validarEnvio" class="text-danger">
                    {{ errores.categoria }}
                  </div>
                </div>

                <div class="col-md-3" *ngIf="formData.cargo === '2'">
                  <label class="form-label" for="numerolic">
                    <strong>Número de Licencia:</strong> <span class="text-danger">*</span>
                  </label>
                  <input #inputNumerolic id="numerolic" type="number" class="form-control fs-14"
                    [(ngModel)]="formData.numerolic" name="numerolic" required (change)="validarCargo()" [ngClass]="{
                      'is-invalid': errores.numerolic && validarEnvio
                    }" />
                  <div class="invalid-feedback" *ngIf="errores.numerolic && validarEnvio">
                    {{ errores.numerolic }}
                  </div>
                </div>

                <div class="col-md-3" *ngIf="formData.cargo === '2'">
                  <label class="form-label" for="expediciolic">
                   <strong>Fecha Expedición:</strong> <span class="text-danger">*</span>
                  </label>
                  <div class="input-group input-group-sm">
                    <input #inputExpedicioLic placeholder="yyyy-mm-dd" id="expediciolic" type="date"
                      class="form-control form-control-lg fs-14" [(ngModel)]="formData.expediciolic"
                      (ngModelChange)="onDateChange($event, 'ExpedicioLic')" name="expediciolic" required
                      [max]="fechaMaximaExpedicion" [ngClass]="{
                        'is-invalid': errores.expediciolic && validarEnvio
                      }" />
                  </div>
                  <div class="invalid-feedback" *ngIf="errores.expediciolic && validarEnvio">
                    {{ errores.expediciolic }}
                  </div>
                </div>

                <div class="col-md-3" *ngIf="formData.cargo === '2'">
                  <label class="form-label" for="vencelic"><strong>Fecha de Vencimiento:</strong></label>
                  <div class="input-group input-group-sm">
                    <input #inputFechaVenceLic id="vencelic" type="date" class="form-control form-control-lg fs-14"
                      [(ngModel)]="formData.vencelic" (ngModelChange)="onDateChange($event, 'fechaVenceLic')"
                      name="vencelic" required [min]="fechaMinimaPermitida" [ngClass]="{
                        'is-invalid': errores.vencelic && validarEnvio
                      }" />
                  </div>
                  <div class="invalid-feedback" *ngIf="errores.vencelic && validarEnvio">
                    {{ errores.vencelic }}
                  </div>
                </div>

                <div class="col-md-3">
                  <label class="form-label" for=""><strong>Tipo de Contrato:</strong></label>
                  <ng-select id="tipocontrato" [items]="tipocontratoData" bindLabel="descripcion" bindValue="id"
                    placeholder="Seleciona una opción" class="js-example-placeholder-multiple"
                    [(ngModel)]="formData.tipocontrato" name="tipocontrato">
                  </ng-select>
                </div>
                <div class="col-md-3">
                  <label class="form-label" for=""><strong>Jornada Laboral:</strong></label>
                  <ng-select id="jornada" [items]="JornadaLaboral" bindLabel="label" bindValue="label"
                    placeholder="Seleciona una opción" class="js-example-placeholder-multiple"
                    [(ngModel)]="formData.jornada" name="jornada">
                  </ng-select>
                </div>

                <div class="col-md-3">
                  <label class="form-label" for="fechacontrato"><strong>Firma de Contrato:</strong></label>
                  <div class="input-group input-group-sm">
                    <input id="firmacontrato" type="date" class="form-control form-control-lg fs-14"
                      [(ngModel)]="formData.firmacontrato" name="firmacontrato" [max]="fechaMaximaExpedicion"
                      (ngModelChange)="onDateChange($event, 'FirmaContrato')" />
                  </div>
                  <div class="valid-feedback">¡Se ve bien!</div>
                </div>

                <div class="col-md-3">
                  <label class="form-label" for="vencecontrato"><strong>Vencimiento de Contrato:</strong></label>
                  <div class="input-group input-group-sm">
                    <input id="vencecontrato" type="date" class="form-control form-control-lg fs-14"
                      [(ngModel)]="formData.vencecontrato" name="vencecontrato" [min]="fechaMinimaPermitida"
                      (ngModelChange)="onDateChange($event, 'VenceContrato')" />
                  </div>
                  <div class="valid-feedback">¡Se ve bien!</div>
                </div>

                <div class="col-md-3">
                  <label class="form-label" for=""> <strong>Lugar de Trabajo:</strong></label>
                  <ng-select id="lugartrabajo" [items]="municipios" bindLabel="MUNICIPIO" bindValue="IDMUN"
                    placeholder="Seleciona una opción" class="js-example-placeholder-multiple"
                    [(ngModel)]="formData.lugartrabajo" name="lugartrabajo">
                  </ng-select>
                </div>
                <div class="col-md-3">
                  <label class="form-label" for=""><strong>Sueldo:</strong></label>
                  <input class="form-control" id="sueldo" type="number" placeholder="Ingrese sueldo"
                    [(ngModel)]="formData.sueldo" name="sueldo" />
                </div>

                <div class="col-md-3">
                  <label class="form-label" for="validationCustom01">
                   <strong>Asume Seguridad Social:</strong></label>
                  <ng-select id="asumess" [items]="seguridadsocialData" bindLabel="descripcion" bindValue="id"
                    placeholder="Seleciona una opción" class="js-example-placeholder-multiple"
                    [(ngModel)]="formData.asumess" name="asumess">
                  </ng-select>
                </div>

                <div class="col-md-3">
                  <label class="form-label" for="validationCustom01"><strong>Consulta PONAL:</strong></label>
                  <div class="input-group input-group-sm">
                    <input id="fechaponal" class="form-control form-control-lg" type="date" placeholder="yyyy-mm-dd"
                      [(ngModel)]="formData.fechaponal" name="fechaponal"
                      (ngModelChange)="onDateChange($event, 'FechaPonal')" />
                  </div>
                </div>
                <div class="col-md-3">
                  <label class="form-label" for="resultadoponal"><strong>Resultado PONAL:</strong></label>
                  <ng-select id="resultadoponal" [items]="ResultadoPonal" bindLabel="label" bindValue="label"
                    placeholder="Selecciona una opción" class="js-example-placeholder-multiple"
                    [(ngModel)]="formData.resultadoponal" name="resultadoponal" (change)="onChangeResultado()">
                  </ng-select>
                </div>

                <div class="col-md-3" *ngIf="formData.resultadoponal === 'CON ANTECEDENTES'">
                  <label class="form-label" for="resultadoponal">
                    <strong>ANTECEDENTES PONAL:</strong></label>
                  <input id="anteponal" type="text" class="form-control" placeholder="Ingrese antecedentes ponal"
                    [(ngModel)]="formData.anteponal" name="anteponal" />
                </div>

                <div class="col-md-3">
                  <label class="form-label" for=""><strong>Consulta PROCURADURIA:</strong></label>
                  <div class="input-group input-group-sm">
                    <input id="fechaprocu" class="form-control form-control-lg fs-14" type="date"
                      placeholder="yyyy-mm-dd" [(ngModel)]="formData.fechaprocu" name="fechaprocu"
                      (ngModelChange)="onDateChange($event, 'FechaProcu')" />
                  </div>
                </div>
                <div class="col-md-3">
                  <label class="form-label" for=""><strong>Resultado PROCURADURIA:</strong></label>
                  <ng-select id="resultadoprocu" [items]="ResultadoPonal" bindLabel="label" bindValue="label"
                    placeholder="Selecciona una opción" class="js-example-placeholder-multiple"
                    [(ngModel)]="formData.resultadoprocu" name="resultadoprocu">
                  </ng-select>
                </div>
                <div class="col-md-3" *ngIf="formData.resultadoprocu === 'CON ANTECEDENTES'">
                  <label class="form-label" for="anteprocu"><strong>ANTECEDENTES PROCURADURIA:</strong></label>
                  <input id="anteprocu" class="form-control" placeholder="Ingrese antecedentes procuraduria"
                    [(ngModel)]="formData.anteprocu" name="anteprocu" />
                </div>


              </div>
            </form>
          </div>
        </div>
      </ng-template>
    </ngb-panel>

    <ngb-panel id="static-3">
      <ng-template ngbPanelTitle>
        <i class="fa fa-child"></i>
        <span class="ms-2"><strong>Dotación</strong></span>
      </ng-template>
      <ng-template ngbPanelContent>
        <div class="card">
          <div class="card-header">
            <form [ngClass]="{ 'was-validated': validate }" class="needs-validation" novalidate>
              <div class="row g-3 mb-3">
                <div class="col-md-3">
                  <label class="form-label" for="validationCustom01">
                    <strong>Talla Camisa:</strong></label>
                  <input class="form-control" id="camisa" type="text" placeholder="Ingrese talla"
                    [(ngModel)]="formData.camisa" name="camisa" />
                </div>
                <div class="col-md-3">
                  <label class="form-label" for=""><strong>Talla Pantalón:</strong></label>
                  <input class="form-control" id="pantalon" type="text" placeholder="Ingrese talla"
                    [(ngModel)]="formData.pantalon" name="pantalon" />
                </div>
                <div class="col-md-3">
                  <label class="form-label" for=""><strong>Talla Zapatos:</strong></label>
                  <input class="form-control" id="zapatos" type="text" placeholder="Ingrese talla"
                    [(ngModel)]="formData.zapatos" name="zapatos" />
                </div>
                <div class="col-md-3">
                  <label class="form-label" for="peso"><strong>Peso (KG):</strong></label>
                  <input class="form-control" id="peso" type="text" [(ngModel)]="formData.peso"
                    (input)="formData.peso = formData.peso?.toString().replace(',', '.')" (keyup)="calcularIMC()"
                    name="peso" placeholder="Ingrese su peso" />
                </div>

              </div>

              <div class="row g-3 mb-3">
                <div class="col-md-3">
                  <label class="form-label" for="altura"><strong>Altura (CM):</strong></label>
                  <input class="form-control" id="altura" type="number" [(ngModel)]="formData.altura"
                    (blur)="calcularIMC()" name="altura" placeholder="Ingrese su altura en cm" />
                </div>
                <div class="col-md-3">
                  <label class="form-label" for="imc"><strong>IMC:</strong></label>
                  <input class="form-control" id="imc" type="text" [(ngModel)]="formData.imc" name="imc" disabled />
                </div>

                <div class="col-md-3">
                  <label class="form-label" for="resultadoimc"><strong>Resultado IMC:</strong></label>
                  <input class="form-control" id="resultadoimc" type="text" [(ngModel)]="formData.resultadoimc"
                    name="resultadoimc" disabled />
                </div>
              </div>

              <br />
            </form>
          </div>
        </div>
      </ng-template>
    </ngb-panel>

    <ngb-panel id="static-4">
      <ng-template ngbPanelTitle>
        <i class="fa fa-medkit"></i>
        <span class="ms-2"><strong>Seguridad Social</strong></span>
      </ng-template>
      <ng-template ngbPanelContent>
        <div class="card">
          <form [ngClass]="{ 'was-validated': validate }" class="needs-validation" novalidate (ngSubmit)="saveData()">
            <div class="card card-absolute">
              <div class="card-header bg-primary">
                <h5 class="text-white">EPS</h5>
              </div>
              <div class="card-body">
                <div class="row g-3 mb-3">
                  <div class="col-md-4">
                    <label class="form-label" for="eps"><strong>Entidad:</strong></label>
                    <ng-select id="eps" [items]="empresas" bindLabel="nombre" bindValue="nit"
                      placeholder="Seleciona una opción" class="js-example-placeholder-multiple"
                      [(ngModel)]="formData.eps" (click)="filtrarPorEps()" name="eps">
                    </ng-select>
                  </div>
                  <div class="col-md-4">
                    <label class="form-label" for="fechaeps"><strong>Fecha de Afiliación:</strong></label>
                    <div class="input-group input-group-sm">
                      <input id="fechaeps" class="form-control form-control-lg" type="date" placeholder="yyyy-mm-dd"
                        [(ngModel)]="formData.fechaeps" name="fechaeps" [max]="fechaMaximaExpedicion"
                        (ngModelChange)="onDateChange($event, 'FechaEps')" />
                    </div>
                    <div class="valid-feedback">¡Se ve bien!</div>
                  </div>
                  <div class="col-md-4">
                    <label class="form-label" for="fechacobeps"><strong>Fecha de Cobertura:</strong></label>
                    <div class="input-group input-group-sm">
                      <input id="fechacobeps" class="form-control form-control-lg" type="date" placeholder="yyyy-mm-dd"
                        [(ngModel)]="formData.fechacobeps" name="fechacobeps" [min]="fechaMinimaPermitida"
                        (ngModelChange)="onDateChange($event, 'FechaCobEps')" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card card-absolute">
              <div class="card-header bg-primary">
                <h5 class="text-white">ARL</h5>
              </div>
              <div class="card-body">
                <div class="row g-3 mb-3">
                  <div class="col-md-4">
                    <label class="form-label" for="arl"> <strong>Entidad:</strong></label>
                    <ng-select id="arl" [items]="empresaARL" bindLabel="nombre" bindValue="nit"
                      placeholder="Seleciona una opción" class="js-example-placeholder-multiple"
                      [(ngModel)]="formData.arl" name="arl">
                    </ng-select>
                  </div>
                  <div class="col-md-4">
                    <label class="form-label" for="">
                      <strong>Fecha de Afiliación:</strong></label>
                    <div class="input-group input-group-sm">
                      <input id="fechaarl" type="date" class="form-control form-control-lg" placeholder="yyyy-mm-dd"
                        [(ngModel)]="formData.fechaarl" name="fechaarl" [max]="fechaMaximaExpedicion"
                        (ngModelChange)="onDateChange($event, 'FechaArl')" />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <label class="form-label" for=" ">
                      <strong>Fecha de Cobertura:</strong></label>
                    <div class="input-group input-group-sm">
                      <input id="fechacobarl" type="date" class="form-control form-control-lg" placeholder="yyyy-mm-dd"
                        [(ngModel)]="formData.fechacobarl" name="fechacobarl" [min]="fechaMinimaPermitida"
                        (ngModelChange)="onDateChange($event, 'FechaCobArl')" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="card card-absolute">
              <div class="card-header bg-primary">
                <h5 class="text-white">FONDO DE PENSIONES</h5>
              </div>
              <div class="card-body">
                <div class="row g-3 mb-3">
                  <div class="col-md-4">
                    <label class="form-label" for="afp"> <strong>Entidad:</strong></label>
                    <ng-select id="afp" [items]="empresaAFP" bindLabel="nombre" bindValue="nit"
                      placeholder="Seleciona una opción" class="js-example-placeholder-multiple"
                      [(ngModel)]="formData.afp" (click)="filtrarPorFondoPensiones()" name="afp">
                    </ng-select>
                  </div>
                  <div class="col-md-4">
                    <label class="form-label" for=" ">
                      <strong>Fecha de Afiliación:</strong></label>
                    <div class="input-group input-group-sm">
                      <input id="fechaafp" class="form-control form-control-lg" type="date" placeholder="yyyy-mm-dd"
                        [(ngModel)]="formData.fechaafp" name="fechaafp" [max]="fechaMaximaExpedicion"
                        (ngModelChange)="onDateChange($event, 'FechaAfp')" />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <label class="form-label" for=" ">
                      <strong>Fecha de Cobertura:</strong></label>
                    <div class="input-group input-group-sm">
                      <input id="fechacobafp" class="form-control form-control-lg" type="date" placeholder="yyyy-mm-dd"
                        [(ngModel)]="formData.fechacobafp" name="fechacobafp" [min]="fechaMinimaPermitida"
                        (ngModelChange)="onDateChange($event, 'FechaCobAfp')" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="card card-absolute">
              <div class="card-header bg-primary">
                <h5 class="text-white">CESANTIAS</h5>
              </div>
              <div class="card-body">
                <div class="row g-3 mb-3">
                  <div class="col-md-4">
                    <label class="form-label" for="ces"><strong>Entidad:</strong></label>
                    <ng-select id="ces" [items]="empresaCES" bindLabel="nombre" bindValue="nit"
                      placeholder="Seleciona una opción" class="js-example-placeholder-multiple"
                      [(ngModel)]="formData.ces" (click)="filtrarPorCesantias()" name="ces">
                    </ng-select>
                  </div>
                  <div class="col-md-4">
                    <label class="form-label" for=" ">
                      <strong>Fecha de Afiliación:</strong></label>
                    <div class="input-group input-group-sm">
                      <input id="fechaces" type="date" class="form-control form-control-lg" placeholder="yyyy-mm-dd"
                        [(ngModel)]="formData.fechaces" name="fechaces" [max]="fechaMaximaExpedicion"
                        (ngModelChange)="onDateChange($event, 'FechaCes')" />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <label class="form-label" for=" ">
                      <strong>Fecha de Cobertura:</strong></label>
                    <div class="input-group input-group-sm">
                      <input id="fechacobces" class="form-control form-control-lg" type="date" placeholder="yyyy-mm-dd"
                        [(ngModel)]="formData.fechacobces" name="fechacobces" [min]="fechaMinimaPermitida"
                        (ngModelChange)="onDateChange($event, 'FechaCobCes')" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="card card-absolute">
              <div class="card-header bg-primary">
                <h5 class="text-white">CAJA DE COMPENSACIÓN FAMILIAR</h5>
              </div>
              <div class="card-body">
                <div class="row g-3 mb-3">
                  <div class="col-md-4">
                    <label class="form-label" for="ccf"><strong>Entidad:</strong></label>
                    <ng-select id="ccf" [items]="empresaCCF" bindLabel="nombre" bindValue="nit"
                      placeholder="Seleciona una opción" class="js-example-placeholder-multiple"
                      [(ngModel)]="formData.ccf" (click)="filtrarPorCajaCompensacion()" name="ccf">
                    </ng-select>
                  </div>
                  <div class="col-md-4">
                    <label class="form-label" for=" ">
                     <strong>Fecha de Afiliación:</strong></label>
                    <div class="input-group input-group-sm">
                      <input id="fechaccf" class="form-control form-control-lg" type="date" placeholder="yyyy-mm-dd"
                        [(ngModel)]="formData.fechaccf" name="fechaccf" [max]="fechaMaximaExpedicion"
                        (ngModelChange)="onDateChange($event, 'FechaCcf')" />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <label class="form-label" for="">
                      <strong>Fecha de Cobertura:</strong></label>
                    <div class="input-group input-group-sm">
                      <input id="fechacobeccf" class="form-control form-control-lg fs-14" type="date"
                        [(ngModel)]="formData.fechacobeccf" name="fechacobeccf" [min]="fechaMinimaPermitida"
                        (ngModelChange)="onDateChange($event, 'FechaCobEccf')" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </ng-template>
    </ngb-panel>

    <!--
    <ngb-panel id="static-3" title="Disabled" [disabled]="true">
      <ng-template ngbPanelContent>
        Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf
        moon officia
        aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf
        moon tempor,
        sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim
        keffiyeh helvetica,
        craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo.
        Leggings
        occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them
        accusamus
        labore sustainable VHS.
      </ng-template>
    </ngb-panel>
-->
  </ngb-accordion>
</div>

<div class="btn-showcase my-4">
  <button type="submit" class="btn btn-primary" (click)="withConfirmation()">
    Guardar
  </button>
</div>
</div>